<template>
  <div class="mb25 s_flex_ali">
    <a-input
      v-model:value="addressKeyword"
      class="mr15"
      style="width: 30%"
      placeholder="请输入地址查找相关位置"
      @pressEnter="getAddressKeyword"
    />
    <a-button
      type="primary"
      :disabled="disSearch || !mapReady"
      :loading="spinning"
      @click="getAddressKeyword"
    >
      搜索
    </a-button>
    <div v-if="shopInfo.lat !== '' && shopInfo.lng !== ''" class="s_flex_ali ml40">
      <p class="mr15">已选中地址的经纬度：{{ shopInfo.lat }} - {{ shopInfo.lng }}</p>
      <a-button type="primary" @click="confirm">确认</a-button>
    </div>
  </div>
  <a-spin :spinning="spinning">
    <div ref="mapContainer" class="gd-map__container"></div>
  </a-spin>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, reactive, ref, toRefs } from 'vue'
import { message } from 'ant-design-vue'
import MapLoader from './gdmap.js'

export default {
  name: 'gdmap',
  props: {
    provinceData: {
      type: [String, Object],
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    lat: {
      type: [Number, String],
      default: ''
    },
    lng: {
      type: [Number, String],
      default: ''
    },
    disSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm'],
  setup(props, { emit }) {
    const mapContainer = ref(null)
    const state = reactive({
      addressKeyword: '',
      shopInfo: {
        lng: '',
        lat: ''
      },
      spinning: false,
      mapReady: false
    })

    let map = null
    let marker = null
    let geocoder = null
    let amapApi = null
    let destroyed = false

    const hasInitialLocation = computed(() => {
      return props.lat !== '' && props.lat !== null && props.lat !== undefined &&
        props.lng !== '' && props.lng !== null && props.lng !== undefined
    })

    const getAddressPrefix = () => {
      if (typeof props.provinceData === 'string') {
        return props.provinceData
      }

      const province = props.provinceData || {}
      return [province.province_name, province.city_name, province.area_name]
        .filter(Boolean)
        .join('')
    }

    const addMarker = (lng, lat) => {
      if (!map || !amapApi) return

      if (marker) {
        map.remove(marker)
      }
      marker = new amapApi.Marker({
        position: [lng, lat]
      })
      map.add(marker)
    }

    const selectLocation = (lng, lat) => {
      state.shopInfo = {
        lng,
        lat
      }
      addMarker(lng, lat)
    }

    const initMap = async () => {
      try {
        const AMap = await MapLoader()
        if (destroyed || !mapContainer.value) return

        amapApi = AMap
        const center = hasInitialLocation.value
          ? [Number(props.lng), Number(props.lat)]
          : [113.36199, 23.12463]

        map = new AMap.Map(mapContainer.value, {
          viewMode: '2D',
          zoom: 13,
          center,
          resizeEnable: true
        })
        geocoder = new AMap.Geocoder()
        map.addControl(new AMap.ToolBar())
        addMarker(center[0], center[1])

        if (hasInitialLocation.value) {
          selectLocation(center[0], center[1])
        }

        map.on('click', (event) => {
          selectLocation(event.lnglat.getLng(), event.lnglat.getLat())
        })
        state.mapReady = true
      } catch (error) {
        console.error(error)
        message.error(error.message || '高德地图加载失败')
      }
    }

    const getAddressKeyword = () => {
      const keyword = state.addressKeyword.trim()
      if (!keyword) {
        message.warning('请输入要搜索的地址')
        return
      }
      if (keyword.includes('#')) {
        message.error('关键词不能包含#号')
        return
      }
      if (!geocoder) {
        message.warning('地图正在加载，请稍后再试')
        return
      }

      state.spinning = true
      geocoder.getLocation(keyword, (status, result) => {
        try {
          if (status === 'complete' && result.geocodes && result.geocodes.length) {
            const location = result.geocodes[0].location
            selectLocation(location.lng, location.lat)
            map.setCenter([location.lng, location.lat])
          } else {
            message.error('未找到相关地址，请调整关键词后重试')
          }
        } finally {
          state.spinning = false
        }
      })
    }

    const confirm = () => {
      emit('confirm', { ...state.shopInfo })
    }

    const destroy = () => {
      destroyed = true
      state.mapReady = false
      state.spinning = false
      if (map) {
        map.destroy()
      }
      map = null
      marker = null
      geocoder = null
      amapApi = null
    }

    onMounted(() => {
      state.addressKeyword = `${getAddressPrefix()}${props.address || ''}`
      initMap()
    })
    onBeforeUnmount(destroy)

    return {
      ...toRefs(state),
      mapContainer,
      getAddressKeyword,
      confirm,
      destroy
    }
  }
}
</script>

<style lang="less" scoped>
.gd-map__container {
  height: 600px;
  width: 100%;
}
</style>
